var _path, _path2, _rect, _rect2, _rect3, _circle, _circle2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuPlaceHolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 89,
    viewBox: "0 0 97 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6979 1C33.4465 1 30 4.44646 30 8.69787V26.3021C30 30.5535 33.4465 34 37.6979 34H60.3021C64.5535 34 68 30.5535 68 26.3021V8.69787C68 4.44646 64.5535 1 60.3021 1H37.6979ZM39 6C36.7909 6 35 7.79086 35 10V26C35 28.2091 36.7909 30 39 30H59C61.2091 30 63 28.2091 63 26V10C63 7.79086 61.2091 6 59 6H39Z",
    fill: "#E7F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4277 8.69787C30.4277 4.68264 33.6826 1.42766 37.6979 1.42766V0.57234C33.2103 0.57234 29.5723 4.21027 29.5723 8.69787H30.4277ZM30.4277 26.3021V8.69787H29.5723V26.3021H30.4277ZM37.6979 33.5723C33.6826 33.5723 30.4277 30.3174 30.4277 26.3021H29.5723C29.5723 30.7897 33.2103 34.4277 37.6979 34.4277V33.5723ZM60.3021 33.5723H37.6979V34.4277H60.3021V33.5723ZM67.5723 26.3021C67.5723 30.3174 64.3174 33.5723 60.3021 33.5723V34.4277C64.7897 34.4277 68.4277 30.7897 68.4277 26.3021H67.5723ZM67.5723 8.69787V26.3021H68.4277V8.69787H67.5723ZM60.3021 1.42766C64.3174 1.42766 67.5723 4.68264 67.5723 8.69787H68.4277C68.4277 4.21027 64.7897 0.57234 60.3021 0.57234V1.42766ZM37.6979 1.42766H60.3021V0.57234H37.6979V1.42766ZM35.4277 10C35.4277 8.02705 37.0271 6.42766 39 6.42766V5.57234C36.5547 5.57234 34.5723 7.55467 34.5723 10H35.4277ZM35.4277 26V10H34.5723V26H35.4277ZM39 29.5723C37.0271 29.5723 35.4277 27.9729 35.4277 26H34.5723C34.5723 28.4453 36.5547 30.4277 39 30.4277V29.5723ZM59 29.5723H39V30.4277H59V29.5723ZM62.5723 26C62.5723 27.9729 60.9729 29.5723 59 29.5723V30.4277C61.4453 30.4277 63.4277 28.4453 63.4277 26H62.5723ZM62.5723 10V26H63.4277V10H62.5723ZM59 6.42766C60.9729 6.42766 62.5723 8.02705 62.5723 10H63.4277C63.4277 7.55467 61.4453 5.57234 59 5.57234V6.42766ZM39 6.42766H59V5.57234H39V6.42766Z",
    fill: "#C8CDDB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 85,
    height: 72,
    rx: 7.69787,
    fill: "#E7F0FF",
    stroke: "#C8CDDB",
    strokeWidth: 0.855319
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 95,
    height: 55,
    rx: 7.69787,
    fill: "white",
    stroke: "#C8CDDB",
    strokeWidth: 0.855319
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 63,
    width: 12,
    height: 15,
    rx: 3,
    fill: "white",
    stroke: "#C8CDDB",
    strokeWidth: 0.855319
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2.36587,
    transform: "matrix(0.999914 0.0130896 0 1 31.3657 45.6605)",
    fill: "#6B7DAB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.36587,
    transform: "matrix(0.999914 0.0130896 0 1 66.6235 45.8578)",
    fill: "#6B7DAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1179 50.7147C54.1179 47.5788 51.7878 45.0061 48.9135 44.9685C46.0391 44.9309 43.709 47.4426 43.709 50.5785",
    stroke: "#6B7DAB",
    strokeWidth: 0.855319
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6776 56.7153C34.6776 58.2833 33.4066 59.5377 31.8388 59.5172C30.271 59.4967 29 58.2089 29 56.641C29 53.8019 31.8388 51.0001 31.8388 51.0001C31.8388 51.0001 34.6776 53.8763 34.6776 56.7153Z",
    fill: "url(#paint0_linear_756_49268)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_756_49268",
    x1: 31.8388,
    y1: 51.0001,
    x2: 31.7273,
    y2: 59.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB3F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuPlaceHolder);
export default __webpack_public_path__ + "static/media/buPlaceHolder.fa9f14c766f9e436cd468e4b2192cab0.svg";
export { ForwardRef as ReactComponent };